import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";


//Atpl-server
// const firebaseConfig = {
//     apiKey: "AIzaSyBSika0Kw5PZHrM4y81DEEw4xF5GxDa3zU",
//     authDomain: "bu-chat-c678e.firebaseapp.com",
//     projectId: "bu-chat-c678e",
//     storageBucket: "bu-chat-c678e.firebasestorage.app",
//     messagingSenderId: "30081921859",
//     appId: "1:30081921859:web:34b5cf65cbfeb24041f5f6",
//     measurementId: "G-2RN031BVMV"
// };




//BU-server
const firebaseConfig = {
    apiKey: "AIzaSyBU6hVeSTShMX0naC7bDRkjOvaZQgCeZF8",
    authDomain: "bu-admin-chat.firebaseapp.com",
    projectId: "bu-admin-chat",
    storageBucket: "bu-admin-chat.firebasestorage.app",
    messagingSenderId: "35317662760",
    appId: "1:35317662760:web:7453214ce413457f96211d",
    measurementId: "G-JJPVJPRJBE"
};







// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const requestForToken = async () => {
    try {
        const supported = await isSupported();
        if (!supported) {
            console.warn("Firebase Messaging is not supported in this environment.");
            return null;
        }

        if (typeof Notification === "undefined") {
            console.warn("Notification API not available.");
            return null;
        }

        let permission = Notification.permission;
        if (permission === "denied") {
            // User blocked notifications. Skip silently.
            return null;
        }
        if (permission === "default") {
            permission = await Notification.requestPermission();
        }
        if (permission !== "granted") {
            return null;
        }

        const messaging = getMessaging(app);
        const swRegistration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
        const currentToken = await getToken(messaging, {
            vapidKey: "BJhuNRbjnxabGiYJv65lnOqFScBCybJjKdBMbdAeTuJ3Hgjz4Lnqlij024JHTUvqKlLd0bfvzdtbNm2Yb1hlAkk",
            serviceWorkerRegistration: swRegistration,
        });
        
        if (currentToken) {
            console.log('FCM Token:', currentToken);
            // Send the token to your server and update the UI if necessary
            return currentToken;
        } else {
            console.log('No registration token available. Request permission to generate one.');
            return null;
        }
    } catch (err) {
        console.error('An error occurred while retrieving token. ', err);
        return null;
    }
};

export const onMessageListener = async (callback) => {
    try {
        const supported = await isSupported();
        if (!supported) return;

        const messaging = getMessaging(app);
        return onMessage(messaging, (payload) => {
            callback(payload);
        });
    } catch (err) {
        console.error("Failed to setup onMessageListener:", err);
    }
};
